import { CustomError } from '@geta/kolumbus-frontend/features/common';

export class GeolocationError extends CustomError {
    constructor(message: string) {
        super('GeolocationError', message);
    }
}

export class PlacesError extends CustomError {
    constructor(message: string) {
        super('PlacesError', message);
    }
}

export class BookingError extends CustomError {
    constructor(message: string) {
        super('BookingError', message);
    }
}

export class SearchError extends CustomError {
    constructor(message: string) {
        super('SearchError', message);
    }
}
